module.exports = __webpack_public_path__ + "static/media/banner_home_02.d85dff4b.png";